module.exports = __webpack_public_path__ + "static/media/BaseOil.f2e5afdf.jpg";